import React from 'react';
import { UIHeading2 } from '@cian/ui-kit/typography';
import { Link } from '../Link/Link';
import styles from './ReviewItem.css';

export interface IReview {
  title: string;
  imageUrl: string;
  url: string;
}

type TReviewItemProps = IReview;

export const ReviewItem: React.FC<TReviewItemProps> = ({ title, imageUrl, url }) => {
  return (
    <Link href={url} className={styles['link']}>
      <div
        className={styles['image']}
        style={{
          backgroundImage: `url(${imageUrl})`,
        }}
      ></div>
      <div className={styles['content']}>
        <UIHeading2 color="white_100">{title}</UIHeading2>
      </div>
    </Link>
  );
};
